import React from 'react';

import CityAutocompleteSingleV2 from 'common/CityAutocompleteSingleV2';

/**
 * "Replacement departure location" — city autocomplete used inside the
 * fatigueReplacement / driverOutOfHoursReplacement leaves. Emits `{ fromCityId,
 * fromCityName }`; the parent leaf owns the containing "replacement box"
 * layout so it can render the driver picker between location and ETD/ETA.
 *
 * @param {{
 *   value: { fromCityId: string, fromCityName?: string },
 *   onChange: (next: { fromCityId: string, fromCityName: string }) => void,
 * }} props
 */
const ReplacementDepartureLocationInput = ({ value, onChange }) => {
	const fromCityId = value?.fromCityId ?? '';
	const fromCityName = value?.fromCityName ?? '';

	const handleSelection = ({ id, name }) => onChange({ fromCityId: id, fromCityName: name });
	const handleReset = () => onChange({ fromCityId: '', fromCityName: '' });

	return (
		<CityAutocompleteSingleV2
			label="Replacement departure location"
			defaultValue={fromCityId ? { id: fromCityId, name: fromCityName } : null}
			onSelection={handleSelection}
			onReset={handleReset}
			optionsToDisplay={3}
		/>
	);
};

export default ReplacementDepartureLocationInput;
